__turbopack_context__.v({
  "container": "kQQ5EW_container",
  "container--collapsed": "kQQ5EW_container--collapsed",
  "container--expanded": "kQQ5EW_container--expanded",
  "link": "kQQ5EW_link",
  "showMoreButton": "kQQ5EW_showMoreButton",
  "showMoreButton--collapsed": "kQQ5EW_showMoreButton--collapsed",
  "showMoreButton--expanded": "kQQ5EW_showMoreButton--expanded",
  "showMoreContainer": "kQQ5EW_showMoreContainer",
  "textWrapper": "kQQ5EW_textWrapper",
  "textWrapper--collapsed": "kQQ5EW_textWrapper--collapsed",
});
